import { PREDEFINED_SECTIONS, PredefinedSection, usePredefinedSectionFilter } from './predefined-sections'
import style from './workout-screen.module.scss'
import React from 'react'
import { WorkoutThemedSection } from 'src/component/workout-themed-section/workout-themed-section'

/**
 * Default Workouts view shown when no filter is active: the four predefined sections (Dumbbell,
 * Bodyweight, Barbell, Express) in fixed order, each with a curated preview and a See All link to
 * its dedicated landing page (GH-754).
 */
export const SectionsView = (): React.ReactElement => {
  return (
    <div>
      {PREDEFINED_SECTIONS.map((section, idx) => (
        <div key={section.slug} className={idx % 2 === 0 ? style.whiteBg : style.darkBg}>
          <PredefinedThemedSection section={section} theme={idx % 2 === 0 ? 'light' : 'dark'} />
        </div>
      ))}
    </div>
  )
}

/** One predefined section's preview row. Split into its own component so each can resolve its filter. */
const PredefinedThemedSection = ({
  section,
  theme,
}: {
  section: PredefinedSection
  theme: 'dark' | 'light'
}): React.ReactElement | null => {
  const { filter, isLoading } = usePredefinedSectionFilter(section.slug)
  // Settled with no resolvable filter (e.g. Express durations failed to load): hide the section
  // rather than letting WorkoutThemedSection query with no filter and preview every workout.
  if (!isLoading && !filter) {
    return null
  }
  return (
    <WorkoutThemedSection
      theme={theme}
      label={section.label}
      seeAllLink={`/workouts/section/${section.slug}`}
      workoutFilter={filter}
      previewCount={section.previewCount}
      featured={section.featured}
      areSectionsLoading={isLoading}
    />
  )
}
